import { render, staticRenderFns } from "./Self.vue?vue&type=template&id=22da3f28&scoped=true"
import script from "./Self.vue?vue&type=script&lang=js"
export * from "./Self.vue?vue&type=script&lang=js"
import style0 from "./Self.vue?vue&type=style&index=0&id=22da3f28&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da3f28",
  null
  
)

export default component.exports